import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Snackbar,
  Tab,
  Tabs,
  Box,
  IconButton,
} from "@material-ui/core";
import React, { useContext, useEffect, useState } from "react";
import Notification from "../common/Notification";
import UserMenu from "../common/UserMenu";
import { Link, useHistory } from "react-router-dom";
import AuthContext from "../../store/auth-context";
import { patientService } from "../../services/patient.service";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { bookAppointmentService } from "../../services/bookAppointment.service";
import { Alert, TabContext, TabList, TabPanel } from "@material-ui/lab";
import { finddoctorservice } from "../../services/findDoctor.services";
import { useTranslation } from "react-i18next";
import Parser from "html-react-parser";
import CloseIcon from "@material-ui/icons/Close";
import NoDataResons from "../common/NoDataResons";
import { pushToDataLayer } from "../../utils/gtm";

const BookAppointment = () => {
  const authCtx = useContext(AuthContext);
  const history = useHistory();
  const [t] = useTranslation();
  const [cancelModel, setCancelModel] = useState<boolean>(false);
  const [cancelItem, setCancelItem] = useState<any>({});
  //const [reason, setReason] = useState<any>("");
  let reason: string = "";
  const [cancelShow, setCancelShow] = useState<boolean>(false);
  const [cancelShowmessage, setCancelShowMessage] = useState<any>("");

  const [patientIdHISList, setPatientIdHISList] = useState<any>([]);
  //const [patientIdList, setPatientIdList] = useState<any>([]);
  const [userName, setUserName] = useState<any>("");

  const [upcomingAppt, setUpcomingAppts] = useState<any>([]);
  const [pastAppts, setpastAppts] = useState<any>([]);

  const [familyMemberList, setFamilyMemberList] = useState<any>([]);
  const [familyMemberId, setFamilyMemberId] = useState<any>(0);
  const [isLoadPastAppt, setIsLoadPastAppt] = useState<boolean>(true);
  const [isLoadUpcomingAppt, setIsLoadUpcomingAppt] = useState<boolean>(true);
  const [tabListValue, setTabListValue] = useState("1");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [facilityId, setFacilityId] = useState<string>("");
  const [hospitallocationList, setHospitalLocationList] = useState<any>([]);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [modalText, setModalText] = useState<string>("");
  const [modalType, setModalType] = useState<string>("error");
  const [openResonDialog, setOpenResonDialog] = useState<boolean>(false);
  // const open = Boolean(anchorEl);

  let upcomingAppointmentsArr: any = [];
  let pastAppointmentsArr: any = [];
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const appConfiguration = JSON.parse(
    localStorage.getItem("appConfiguration") || "{}"
  );

  const handleClose = () => setCancelModel(false);
  const handleOpen = () => setCancelModel(true);
  const handleModelClose = () => setShowModal(false);

  useEffect(() => {
    if (user.facilityId) {
      setFacilityId(user.facilityId);
    } else {
      setFacilityId("");
    }

    const getLocation = () => {
      getAllHospitalLocations();
    };
    getLocation();

    const getFamilyList = () => {
      fetchFamilyMember();
    };
    getFamilyList();

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (hospitallocationList.length > 0) {
      const getpatient = () => {
        getPatientRecord();
      };

      getpatient();
    }

    // eslint-disable-next-line
  }, [familyMemberId, hospitallocationList, facilityId]);

  const fetchFamilyMember = async () => {
    const familyMembers = JSON.parse(
      localStorage.getItem("familyMemberList") || "[]"
    );
    setFamilyMemberList(familyMembers);
  };

  const getAllHospitalLocations = async () => {
    authCtx.toggleLoader(true);
    let res = await finddoctorservice.getLocations();
    if (res.data && res.data.status === "success") {
      setHospitalLocationList(res.data.data);
    } else {
      setModalText(t("Error"));
      setModalType("error");
      setShowModal(true);
    }
    authCtx.toggleLoader(false);
  };

  const getPatientRecord = async () => {
    authCtx.toggleLoader(true);
    let idList;
    setPatientIdHISList([]);
    setUpcomingAppts([]);
    setpastAppts([]);
    setIsLoading(true);
    const currentHis: any = hospitallocationList.find(
      (item: any) => item.locationId === facilityId
    );
    const patientRecord = JSON.parse(
      localStorage.getItem("getPatientRecord") || "{}"
    );
    const isPatientRecordCall = localStorage.getItem("isPatientRecordCall");

    if (familyMemberId === 0) {
      setUserName(user.firstName + " " + user.lastName);
    } else {
      familyMemberList &&
        familyMemberList.forEach((item: any) => {
          if (item.familyMemberId === familyMemberId) {
            setUserName(item.firstName + " " + item.lastName);
          }
        });
    }

    if (
      Object.keys(patientRecord).length !== 0 &&
      patientRecord[0].patientId[0] !== "" &&
      isPatientRecordCall === "true" &&
      familyMemberId === 0 &&
      facilityId
    ) {
      await getApptHistory(patientRecord);
    } else {
      let res = await patientService.getPatientRec(
        user.userId,
        familyMemberId,
        facilityId
      );
      if (res && res.data === undefined) {
        idList = [];
        console.log("Somthing went wrong in response");
      } else {
        idList = res.data;
        //setPatientIdList(idList);
      }

      idList &&
        idList.forEach((item: any) => {
          if (
            item &&
            (item.patientId !== null || (item.mobileNo && item.mobileNo !== ""))
          ) {
            if (patientIdHISList.length > 0) {
              if (patientIdHISList.some((obj: any) => obj.his === item.his)) {
                patientIdHISList.forEach((item2: any) => {
                  if (
                    item2.his === item.his &&
                    item2.patientId !== item.patientId
                  ) {
                    item2.patientId = [...item2.patientId, item.patientId];
                  }
                });
              } else {
                let data = {
                  his: item.his,
                  patientId: [item.patientId],
                  mobileNo: item.mobileNo,
                };
                patientIdHISList.push(data);
              }
            } else {
              let data = {
                his: item.his,
                patientId: [item.patientId],
                mobileNo: item.mobileNo,
              };
              patientIdHISList.push(data);
            }
          }
        });

      if (patientIdHISList.length > 0) {
        // if (familyMemberId === 0) {
        //   localStorage.setItem(
        //     "getPatientRecord",
        //     JSON.stringify(patientIdHISList)
        //   );
        //   localStorage.setItem("isPatientRecordCall", "true");
        // }
        await getApptHistory(patientIdHISList);
      } else {
        setIsLoading(false);
      }
    }
    authCtx.toggleLoader(false);
  };

  const getApptHistory = async (idList: any) => {
    authCtx.toggleLoader(true);
    setIsLoading(true);
    await Promise.all(
      idList.map(async (item: any) => {
        const response = await patientService.apptHistory(item);
        if (
          response &&
          response.message &&
          response.message.status &&
          (response.message.status[0] === "S" ||
            response.message.status[0] === "Success")
        ) {
          const upcommingAppt = response.upcomingAppts.map((prop: any) => {
            if (prop.patientId === null || prop.patientId === "") {
              return {
                ...prop,
                patientId: item.patientId[0],
                mobileNo: item.mobileNo,
              };
            } else {
              return {
                ...prop,
                mobileNo: item.mobileNo,
              };
            }
          });
          const pastAppt = response.pastAppts.map((prop: any) => {
            if (prop.patientId === null || prop.patientId === "") {
              return {
                ...prop,
                patientId: item.patientId[0],
                mobileNo: item.mobileNo,
              };
            } else {
              return {
                ...prop,
                mobileNo: item.mobileNo,
              };
            }
          });
          upcomingAppointmentsArr =
            upcomingAppointmentsArr.concat(upcommingAppt);
          pastAppointmentsArr = pastAppointmentsArr.concat(pastAppt);
        }
      })
    );
    if (upcomingAppointmentsArr && upcomingAppointmentsArr.length !== 0) {
      if (facilityId !== "" && appConfiguration.filterToBeApplied) {
        const filterdAppointment = upcomingAppointmentsArr.filter(
          (item: any) => {
            return (
              item.facilityId === facilityId && item.scheduleType !== "TELEMED"
            );
          }
        );
        setUpcomingAppts(filterdAppointment);
      } else {
        const filterdAppointment = upcomingAppointmentsArr.filter(
          (item: any) => {
            return item.scheduleType !== "TELEMED";
          }
        );
        setUpcomingAppts(filterdAppointment);
      }
    } else {
      setUpcomingAppts([]);
      setIsLoadUpcomingAppt(false);
    }

    if (pastAppointmentsArr && pastAppointmentsArr.length !== 0) {
      if (facilityId !== "" && appConfiguration.filterToBeApplied) {
        const filterdPastAppointment = pastAppointmentsArr.filter(
          (item: any) => {
            return (
              item.facilityId === facilityId && item.scheduleType !== "TELEMED"
            );
          }
        );
        setpastAppts(filterdPastAppointment);
      } else {
        const filterdAppointment = pastAppointmentsArr.filter((item: any) => {
          return item.scheduleType !== "TELEMED";
        });
        setpastAppts(filterdAppointment);
      }
    } else {
      setpastAppts([]);
      setIsLoadPastAppt(false);
    }
    setIsLoading(false);
    authCtx.toggleLoader(false);
  };

  const cancelAppt = async () => {
    // Push GTM Event
    pushToDataLayer({
      event: 'form-submit',
      form_name: 'cancel_appointment',
      doctor_name: cancelItem.physicianName,
      hospital_name: cancelItem.location,
      brand_name: appConfiguration?.brandName || 'Burjeel'
    });
    authCtx.toggleLoader(true);
    let response: any;
    let data = {
      facilityId: cancelItem.facilityId,
      appointmentId: cancelItem.appointmentRefNo,
      reason: reason,
      patientId: cancelItem.patientId,
      encryptedSecurityKey: cancelItem.encryptedSecurityKey,
    };
    response = await bookAppointmentService.deleteAppointment(data);

    if (response && response.data !== null) {
      setCancelShow(true);
      setCancelShowMessage(t("Appointment cancelled successfully!"));
      let updatedAppts = upcomingAppt.filter(
        (item: any) => item.appointmentRefNo !== cancelItem.appointmentRefNo
      );
      setUpcomingAppts(updatedAppts);
      setTimeout(() => {
        setCancelShow(false);
      }, 3000);
    }
    authCtx.toggleLoader(false);
    setIsLoadUpcomingAppt(false);
  };

  const handleFamilyChange = (e: any) => {
    setIsLoadUpcomingAppt(true);
    setIsLoadPastAppt(true);
    if (e.target.value === user.firstName + " " + user.lastName) {
      setFamilyMemberId(0);
    } else {
      setFamilyMemberId(Number(e.target.value));
    }
  };

  const handleTabListChange = (event: any, newValue: any) => {
    setTabListValue(newValue);
    // Push GTM Event
    pushToDataLayer({
      event: 'tab_view',
      tab_name: newValue === "1" ? 'Upcoming Appointments' : 'Past Appointments'
    });
  };

  const handleLocationChange = (e: any) => {
    setFacilityId(e.target.value);
  };

  const handleRebookAndReschedule = (item: any, type: string) => {
    // Push GTM Event
    pushToDataLayer({
      event: 'doctor_profile_view',
      doctor_name: item.physicianName,
      specialty_name: item.specialty || 'General', // Use specialty if available in item
      brand_name: appConfiguration?.brandName || 'Burjeel'
    });
    if (type === "reschedule") {
      history.push({
        pathname: "/auth/rescheduleAppointment",
        state: {
          item: item,
          userName: userName,
          fmId: familyMemberId,
          familyMemberList: familyMemberList,
        },
      });
    } else if (type === "rebook") {
      history.push({
        pathname: "/auth/bookPastAppointment",
        state: {
          item: item,
          fmId: familyMemberId,
        },
      });
    }
  };

  const handleBookAppointment = () => {
    pushToDataLayer({ 
      event: 'button_click', 
      button_name: 'Book Appointment', 
      button_location: 'appointments_dashboard',
      brand_name: appConfiguration?.brandName || 'Burjeel' 
    });
    history.push("/auth/finddoctor/");
  };

  const handleResonDialogClose = () => {
    setOpenResonDialog(false);
  };

  const handleReasonDilaogOpen = () => {
    setOpenResonDialog(true);
  };

  const openMobileMenu = (e: any) => {
    e.preventDefault();

    document.getElementById("leftMenu")?.classList.remove("d-none");
  };

  return (
    <>
      <div className="main-content animate py-4 px-3 px-sm-4">
        <div className="d-flex align-items-center mb-3">
          <a
            href="#"
            className="d-inline-block d-sm-none text-dark"
            onClick={(e) => openMobileMenu(e)}
          >
            <i className="material-icons-outlined me-2">menu</i>
          </a>
          <h3 className="fs-18-24">{t("Appointments")}</h3>
          <div
            className={`${authCtx.selectedLanguage === "en" ? "ms-auto" : "mr-auto"
              } mw-90px`}
          >
            <Notification />
            <UserMenu />
          </div>
        </div>
        <div className="card-body p-1 mt-1">
          <div className="card border-0 shadow-sm rounded-1rem">
            <div className="card-body py-2 px-0 position-relative">
  <TabContext value={tabListValue}>
    <Box sx={{ width: "100%" }}>
      <Tabs
        value={tabListValue}
        onChange={handleTabListChange}
        textColor="primary"
        indicatorColor="primary"
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
      >
        <Tab value="1" label={t("Upcoming Appointments")} />
        <Tab value="2" label={t("Past Appointments")} />
      </Tabs>
    </Box>

    {/* Filter Row with Book Appointment Button Integrated */}
    <div className="gx-3 light-bg py-3 row m-0 px-2 align-items-center">
      {appConfiguration.filterToBeApplied && (
        <div className="col-xl-3 col-md-4">
          <div className="form-floating">
            <select
              className="form-select fs-14 no-focus w-100"
              id="selectHospital"
              onChange={(e) => handleLocationChange(e)}
              value={facilityId}
            >
              {hospitallocationList &&
                hospitallocationList.map((item: any, index: any) => (
                  <option key={index} value={item.locationId}>
                    {Parser(item.name)}
                  </option>
                ))}
            </select>
            <label htmlFor="selectHospital">{t("Select Hospital")}</label>
          </div>
        </div>
      )}

      <div className={`col-xl-3 col-md-4 mt-md-0 ${!appConfiguration.filterToBeApplied ? "ms-0" : "mt-3"}`}>
        <div className="form-floating">
          <select
            className="form-select fs-14 no-focus w-100"
            id="selectPatient"
            onChange={(e) => handleFamilyChange(e)}
          >
            <option value={user.firstName + " " + user.lastName}>
              {user.firstName} {user.lastName}
            </option>
            {familyMemberList &&
              familyMemberList.map((item: any, index: any) => (
                <option key={index} value={item.familyMemberId}>
                  {item.firstName} {item.lastName} ({item.relation})
                </option>
              ))}
          </select>
          <label htmlFor="selectPatient">{t("Choose Patient")}</label>
        </div>
      </div>

      {/* Book Appointment Button - Aligned to the Right */}
      <div className="col-xl-3 col-md-4 mt-3 mt-md-0 ms-auto text-md-end">
        <button
          onClick={() => handleBookAppointment()}
          className="btn btn-primary no-focus px-4"
        >
          {t("Book Appointment")}
        </button>
      </div>
    </div>

    {/* Upcoming Appointments Tab */}
    <TabPanel value="1">
      {upcomingAppt && upcomingAppt.length > 0 ? (
        <div className="container-fluid">
          <div className="row align-items-center d-none d-lg-flex">
            <div className="col-lg-4 p-3 fw-600">{t("Doctor")}</div>
            <div className="col-lg-3 p-3 fw-600">{t("Patient")}</div>
            <div className="col-lg-2 p-3 fw-600">{t("Status")}</div>
            <div className="col-lg-3 p-3 fw-600">{t("Action")}</div>
          </div>

          {upcomingAppt.map((item: any, index: any) => (
            <div key={index} className="row border-top align-items-center">
              <div className="col-lg-4 col-sm-6 p-3">
                <div className="d-flex">
                  <div className="flex-shrink-0">
                    <img
                      src={item?.image ? item.image : "/assets/images/doc.png"}
                      alt="img"
                      className="img-h-50 rounded-circle dr-photo"
                    />
                  </div>
                  <div className="flex-grow-1 ms-3 mt-2 text-truncate ln-normal">
                    <label className="fw-bold text-truncate w-100">{item.physicianName}</label>
                    <p className="text-muted fs-12 m-0 text-truncate w-100 mt-1">{item.location}</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-sm-6 px-3 pt-sm-3 pb-3">
                <label className="fw-bold">{userName}</label>
                <p className={`text-muted fs-12 mb-0 mt-1 ${authCtx.selectedLanguage === "en" ? "" : "text-start"}`} dir="ltr">
                  {new Date("1970-01-01T" + item.apptTime + "Z").toLocaleTimeString("en-US", {
                    timeZone: "UTC",
                    hour12: true,
                    hour: "numeric",
                    minute: "numeric",
                  })}{" "}
                  | {new Date(item.apptDate).toDateString()}
                </p>
              </div>
              <div className="col-lg-2 col-sm-6 px-3 py-sm-3">
                <span className="px-3 py-2 rounded-3 light-bg text-primary">
                  {item.appointmentStatus === "0" ? t("Booked") : item.appointmentStatus}
                </span>
              </div>
              <div className="col-lg-3 col-sm-6 p-3">
                <div className="d-flex">
                  {item.appointment_message === null || item.appointment_message.trim() === "" ? (
                    <button
                      onClick={() => handleRebookAndReschedule(item, "reschedule")}
                      className="btn btn-primary no-focus"
                    >
                      {t("Reschedule")}
                    </button>
                  ) : (
                    <a className="btn btn-primary no-focus" href={`tel: ${item.appointment_message}`}>
                      <img className="imageForCall pb-1" src={"/assets/images/phone_white.png"} alt="call" />
                      {item.appointment_message}
                    </a>
                  )}
                  <button
                    className="btn btn-outline-primary no-focus ms-2"
                    onClick={() => {
                      setCancelItem(item);
                      handleOpen();
                    }}
                  >
                    {t("Cancel")}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : isLoading ? (
        <p className="fw-11 text-center text-secondary p-5">{t("Please wait! Loading Appointments")}</p>
      ) : (
        <p className="fw-11 text-center text-secondary p-5">{t("No Upcoming Appointment Found")}</p>
      )}
    </TabPanel>

    {/* Past Appointments Tab */}
    <TabPanel value="2">
      {pastAppts && pastAppts.length > 0 ? (
        <div className="container-fluid">
          <div className="row align-items-center d-none d-lg-flex">
            <div className="col-lg-4 p-3 fw-600">{t("Doctor")}</div>
            <div className="col-lg-3 p-3 fw-600">{t("Patient")}</div>
            <div className="col-lg-3 p-3 fw-600">{t("Status")}</div>
            <div className="col-lg-2 p-3 fw-600">{t("Action")}</div>
          </div>
          {pastAppts.map((item: any, index: any) => (
            <div key={index} className="row border-top align-items-center">
              <div className="col-lg-4 col-sm-6 p-3">
                <div className="d-flex">
                  <div className="flex-shrink-0">
                    <img
                      src={item?.image ? item.image : "/assets/images/doc.png"}
                      alt="img"
                      className="img-h-50 rounded-circle dr-photo"
                    />
                  </div>
                  <div className="flex-grow-1 ms-3 mt-2 text-truncate ln-normal">
                    <label className="fw-bold text-truncate w-100">{item.physicianName}</label>
                    <p className="text-muted fs-12 m-0 text-truncate w-100 mt-1">{item.location}</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-sm-6 px-3 pt-sm-3 pb-3">
                <label className="fw-bold">{userName}</label>
                <p className={`text-muted fs-12 mb-0 mt-1 ${authCtx.selectedLanguage === "en" ? "" : "text-start"}`} dir="ltr">
                  {new Date("1970-01-01T" + item.apptTime + "Z").toLocaleTimeString("en-US", {
                    timeZone: "UTC", hour12: true, hour: "numeric", minute: "numeric",
                  })}{" "}
                  | {new Date(item.apptDate).toDateString()}
                </p>
              </div>
              <div className="col-lg-3 col-sm-6 px-3 py-sm-3">
                <span className={`px-3 py-2 rounded-3 bg-opacity-10 ${item.appointmentStatus === "Not Visited" ? "bg-danger text-danger" : "bg-success text-success"}`}>
                  {item.appointmentStatus}
                </span>
              </div>
              <div className="col-lg-2 col-sm-6 p-3">
                {item.appointment_message === null || item.appointment_message.trim() === "" ? (
                  <button
                    onClick={() => handleRebookAndReschedule(item, "rebook")}
                    className="btn btn-primary w-100 no-focus"
                  >
                    {t("Book")}
                  </button>
                ) : (
                  <a className="btn btn-primary w-100" href={`tel: ${item.appointment_message}`}>
                    <img className="pb-1" src={"/assets/images/phone_white.png"} alt="call" />
                    {item.appointment_message}
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      ) : isLoading ? (
        <p className="fw-11 text-center text-secondary p-5">{t("Please wait! Loading Appointments")}</p>
      ) : (
        <p className="fw-11 text-center text-secondary p-5">{t("No Past Appointment Found")}</p>
      )}
    </TabPanel>

    {/* Footer Help Section */}
    {upcomingAppt?.length === 0 && pastAppts?.length === 0 && !isLoading && (
      <div className="d-flex align-items-center p-3">
        <button
          className="btn btn-link no-focus text-decoration-none ms-auto fs-12"
          onClick={handleReasonDilaogOpen}
        >
          {t("Not able to see the appointments? Click to know the possible reasons.")}
        </button>
      </div>
    )}
  </TabContext>
</div>
          </div>
        </div>
      </div>

      <Dialog open={cancelModel} onClose={handleClose}>
        <DialogTitle>{t("Cancel Appointment")}</DialogTitle>
        <DialogContent>
          <div className="card-body p-4  ln-24">
            <div className="d-flex ">
              <div className="flex-shrink-0">
                {" "}
                <img
                  src={cancelItem.image}
                  alt="img"
                  className="img-75 rounded-circle"
                />{" "}
              </div>
              <div className="flex-grow-1 ms-3">
                <label className="fw-bold">{cancelItem.physicianName}</label>
                <p className="text-muted fs-12 m-0">
                  {new Date(
                    "1970-01-01T" + cancelItem.apptTime + "Z"
                  ).toLocaleTimeString("en-US", {
                    timeZone: "UTC",
                    hour12: true,
                    hour: "numeric",
                    minute: "numeric",
                  })}{" "}
                  {new Date(cancelItem.apptDate).toDateString()}
                </p>
                <p className="text-muted fs-12 m-0">{cancelItem.location}</p>
                <p className="text-muted fs-12 m-0">
                  For <span className="fw-bold">{userName}</span>
                </p>
              </div>
            </div>
          </div>
          <DialogContentText>
            {t("Are you sure, you want to cancel this appointment?")}
          </DialogContentText>
          {/* <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Enter Reason"
            type="text"
            fullWidth
            variant="standard"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          /> */}
        </DialogContent>
        <DialogActions>
          <button className="btn btn-secondary" onClick={handleClose}>
            {t("No")}
          </button>
          <button
            className="btn btn-primary"
            onClick={() => {
              cancelAppt();
              handleClose();
            }}
          >
            {t("Yes")}
          </button>
        </DialogActions>
      </Dialog>

      <Dialog
        fullWidth={true}
        maxWidth="sm"
        open={openResonDialog}
        onClose={handleResonDialogClose}
      >
        <DialogContent className="py-4">
          <NoDataResons from={"appointment"} />
        </DialogContent>
      </Dialog>

      <Snackbar
        open={cancelShow}
        onClose={() => {
          setCancelShow(false);
          setCancelShowMessage("");
        }}
      >
        <Alert onClose={() => setCancelShow(false)} severity="success">
          {cancelShowmessage}
        </Alert>
      </Snackbar>

      {modalType === "error" && (
        <Snackbar
          anchorOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          open={showModal}
          autoHideDuration={3000}
          onClose={handleModelClose}
        >
          <Alert onClose={handleModelClose} severity="error">
            {modalText}
          </Alert>
        </Snackbar>
      )}
      {modalType === "success" && (
        <Snackbar
          anchorOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          open={showModal}
          autoHideDuration={3000}
          onClose={handleModelClose}
        >
          <Alert onClose={handleModelClose} severity="success">
            {modalText}
          </Alert>
        </Snackbar>
      )}
    </>
  );
};

export default BookAppointment;
